import { Recruitment } from 'redux/schemas/models/mentoring-program-recruitments';


// "Who this is for" maps to the recruitment `requirements` field on the backend/flyer.
export const mentorRequirementsDefaultValue = `<ul>
  <li>Open to all employees with an interest in mentoring others</li>
  <li>No prior mentoring experience required</li>
  <li>Able to commit time on a regular basis</li>
</ul>`;

// "What to expect" maps to the recruitment `expectations` field on the backend/flyer.
export const mentorExpectationsDefaultValue = `<ul>
  <li>Meet 1:1 with your mentee on a regular cadence</li>
  <li>Share your experience and career insights</li>
  <li>Set your own capacity and availability</li>
  <li>Accept or decline mentee connection requests</li>
  <li>Meet 1-2 times per month for 30 minutes</li>
</ul>`;

// "Why join?" maps to the recruitment `benefits` field on the backend/flyer.
export const mentorBenefitsDefaultValue = `<ul>
  <li>Develop your coaching and leadership skills</li>
  <li>Expand your professional network</li>
  <li>Give back and support the growth of others</li>
  <li>Build your reputation as a subject matter expert</li>
</ul>`;

export const menteeRequirementsDefaultValue = `<ul>
  <li>Open to all employees looking to grow professionally</li>
  <li>No prior mentoring experience required</li>
  <li>Eager to learn and develop new skills</li>
</ul>`;

export const menteeExpectationsDefaultValue = `<ul>
  <li>Meet 1:1 with your mentor on a regular cadence</li>
  <li>Receive guidance and career insights</li>
  <li>Set learning goals and track your progress</li>
  <li>Meet 1-2 times per month for 30 minutes</li>
</ul>`;

export const menteeBenefitsDefaultValue = `<ul>
  <li>Accelerate your professional growth</li>
  <li>Gain insights from experienced colleagues</li>
  <li>Expand your professional network</li>
  <li>Build new skills and capabilities</li>
</ul>`;

// The default registration-page content that is persisted when a recruitment is first
// created, so the flyer renders with the same values the settings form previews.
export const getDefaultRecruitmentValues = (namePrefix: 'mentor' | 'mentee'): Recruitment => (
  namePrefix === 'mentee'
    ? {
      requirements: menteeRequirementsDefaultValue,
      includeRequirements: true,
      expectations: menteeExpectationsDefaultValue,
      includeExpectations: true,
      benefits: menteeBenefitsDefaultValue,
      includeBenefits: true,
    }
    : {
      requirements: mentorRequirementsDefaultValue,
      includeRequirements: true,
      expectations: mentorExpectationsDefaultValue,
      includeExpectations: true,
      benefits: mentorBenefitsDefaultValue,
      includeBenefits: true,
    }
);
